import styled from "styled-components";

const MenuItem = styled.div`
  height: 64px;
  padding: 0 32px;
  border-top: 2px solid ${({ theme }) => theme.colors.base2};
  box-sizing: border-box;
  font-weight: 600;

  p {
    font-weight: 600;
  }

  a {
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary2};
    display: flex;
    align-items: center;

    font-family: ${({ theme }) => theme.fonts.link.family};
    line-height: ${({ theme }) => theme.fonts.link.lineHeight};
    font-weight: ${({ theme }) => theme.fonts.link.fontWeight};
    letter-spacing: ${({ theme }) => theme.fonts.link.letterSpacing};
  }

  &:last-child {
    border-bottom: 2px solid ${({ theme }) => theme.colors.base2};
  }
`;

export default MenuItem;
